module.exports = __webpack_public_path__ + "img/QuanspireLogoBlack.bcddef02.svg";